import { useState, useCallback, useEffect } from 'react';
import { COOKIES } from '../constants';

const { USER_LAST_LOCATION } = COOKIES;

const useUserLocation = (
  { getCookie, setCookie },
  { loading, location: geoLocation, fetchGeo }
) => {
  const [location, setLocation] = useState(getCookie(USER_LAST_LOCATION) || {});

  const setLocationAll = useCallback(
    obj => {
      setCookie(USER_LAST_LOCATION, obj);
      setLocation(obj);
    },
    [setCookie]
  );

  const setLocationGeo = useCallback(
    callback => {
      fetchGeo(callback);
    },
    [fetchGeo]
  );

  useEffect(() => {
    if (geoLocation) {
      setLocationAll(geoLocation);
    }
  }, [geoLocation, setLocationAll]);

  return {
    location,
    geoLocation,
    setLocation: setLocationAll,
    setLocationGeo,
    loading,
    fetchGeo,
  };
};

export default useUserLocation;
